import React from "react";
import type { FormInstance } from "antd";
import { DynamicFieldsComponent } from "../DynamicFields";
import type { DynamicField } from "../../types";
import type { TemplateDynamicFields } from "../../types";

export interface ConfigTabProps {
  form: FormInstance;
  selectedTemplateId: string | undefined;
  dynamicFieldsValues: Record<string, string>;
  setDynamicFieldsValues: (v: Record<string, string>) => void;
  effectiveTemplateDynamicFields: TemplateDynamicFields | null;
}

export const ConfigTab: React.FC<ConfigTabProps> = ({
  form,
  selectedTemplateId,
  dynamicFieldsValues,
  setDynamicFieldsValues,
  effectiveTemplateDynamicFields,
}) => {
  return (
    <div>
      <DynamicFieldsComponent
        templateId={selectedTemplateId}
        value={Object.entries(dynamicFieldsValues).map(([name, value]) => ({ name, value }))}
        onChange={(fields: DynamicField[]) => {
          const newValues = fields.reduce((acc, field) => {
            acc[field.name] = field.value;
            return acc;
          }, {} as Record<string, string>);
          setDynamicFieldsValues(newValues);
        }}
        form={form}
        templateDynamicFields={effectiveTemplateDynamicFields}
      />
    </div>
  );
};
